import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { IChartElementFeature } from '@tencent/chart-drawer-components/lib/interface';
import { Feature } from '@tencent/workbench';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import isEqual from 'lodash/isEqual';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWOperationType, TDWModuleType, TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { ChartActionType } from '@src/framework/frame-pc/components/chart-component-edit-panel';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import ChartFastLayout from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/chart-fast-layout';
import type { IChartUIFastLayout } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/chart-fast-layout/fast-layout-config';

@Feature({
    name: 'ChartElementFeature',
    adapters: [SLIDE_ADAPTER],
    provide: IChartElementFeature,
})
export class ChartElementFeature extends ChartBaseDrawerFeature implements IChartElementFeature {
    private chartLayout: ChartFastLayout;
    private layouts: IChartUIFastLayout[] = [];

    public toggleTitleVisibility(visible: boolean) {
        const model = this.getSelectModel();
        const { chartProperty } = model;
        visible ? chartProperty.createTitle() : chartProperty?.removeTitle();
        this.report(ChartActionType.TITLE, visible);
    }

    public toggleLegendVisibility(visible: boolean) {
        const model = this.getSelectModel();
        const { chartProperty } = model;
        visible ? chartProperty.createLegend() : chartProperty?.removeLegend();
        this.report(ChartActionType.LEGEND, visible);
    }

    public toggleDataLabelVisibility(visible: boolean) {
        const model = this.getSelectModel();
        const { chartProperty } = model;
        visible ? chartProperty.updateDataLabels() : chartProperty?.removeDataLabels();
        this.report(ChartActionType.DATA_LABELS, visible);
    }

    public toggleAxisVisibility(visible: boolean) {
        const model = this.getSelectModel();
        const { chartProperty } = model;
        visible ? chartProperty.createAllAxes() : chartProperty?.removeAllAxes();
        this.report(ChartActionType.AXIS, visible);
    }

    public toggleAxisTitleVisibility(visible: boolean) {
        const model = this.getSelectModel();
        const { chartProperty } = model;
        visible ? chartProperty.createAllAxesTitle() : chartProperty?.removeAllAxesTitle();
        this.report(ChartActionType.AXIS_TITLE, visible);
    }

    public toggleGridVisibility(visible: boolean) {
        const model = this.getSelectModel();
        const { chartProperty } = model;
        visible ? chartProperty.createAllAxesGridlines() : chartProperty?.removeAllAxesGridlines();
        this.report(ChartActionType.GRIDLINES, visible);
    }

    public toggleTrendlineVisibility(visible: boolean) {
        const model = this.getSelectModel();
        const { chartProperty } = model;
        if (visible) {
            this.getAppService().editableServiceLayer?.chartTrendlineManager.promise().then((chartTrendlineManager) => {
                chartTrendlineManager.showSeriesSelectModal(model);
            });
        } else {
            chartProperty.removeTrendlines();
        }
        this.report(ChartActionType.TRENDLINE, visible);
    }

    public updateLayout(id) {
        const model = this.getSelectModel();
        if (model?.type === UIModelType.CHART) {
            if (!this.chartLayout || this.chartLayout.getCurChartModel() !== model
                || !isEqual(this.chartLayout.getType(), ChartFastLayout.getChartType(model))) {
                this.chartLayout = new ChartFastLayout(model);
                const { type, subType } = this.chartLayout.getType();
                this.layouts  = ChartFastLayout.getChartLayoutConfigs(type, subType);
            }
        }
        const index = Number(id);
        const item = this.layouts[index];
        this.chartLayout?.updateLayout(item.config);
    }

    private report(actionType, value) {
        const ver6Param = JSON.stringify({
            actionType,
            value,
        });

        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.RIGHT_FORMAT_PANEL,
            action: TDWActionType.CHART_ELEMENT,
            ver6: ver6Param,
        });
    }
}
